import logger from '../log';
import AgentData from '../locality/AgentData';
import MonitorData from '../locality/MonitorData';
import ecdn10AgentAPI from '../ecdn10/AgentAPI';
import {
  DetectionData,
  Ecdn10DetectBlock,
  Ecdn10Success
} from '../locality/detect';
import { Ecdn10Data, TenConfig } from './interfaces';
import { setTenData } from './store10AgentInfo';

const log = logger.getLogger(__filename);

export const EMPTY_10_DATA = {
  tenConfig: {} as TenConfig,
  agentData: new AgentData(),
  ecdn10AgentAPI,
  monitorData: new MonitorData(),
  success: false
};

// For unit testing.
export const EMPTY_DETECT_DATA = {
  failures: [
    {
      protocol: 'https',
      request: { name: 'CompositeError' },
      start: 0,
      t: 0
    }
  ]
};

// For unit testing.
export const EMPTY_10_DATA_WITH_FAILURE = {
  ...EMPTY_10_DATA,
  detectData: EMPTY_DETECT_DATA
};

export interface AgentDataRetrieval {
  agentData: AgentData;
  failures: DetectionData[];
  successBlock?: Ecdn10Success;
  success: boolean;
}

export const retrieveAgentData = (
  block?: Ecdn10DetectBlock
): AgentDataRetrieval => {
  return {
    agentData:
      (block && block.success && block.success.data) || new AgentData(),
    failures: (block && block.failures) || [],
    success: block && block.success ? true : false,
    successBlock: block && block.success
  };
};

const getAgentData = async (): Promise<Ecdn10Data> => {
  const detect = (await ecdn10AgentAPI.initialize().catch(e => {
    log.info('10 agent not found', e);
    return undefined;
  })) as Ecdn10DetectBlock | undefined;
  const dataRetrieval = retrieveAgentData(detect);
  const { agentData, failures, successBlock, success } = dataRetrieval;
  const { host, protocol, port } = successBlock || {};
  const tenConfig = { host, port, protocol };
  return {
    agentData,
    detectData: { failures, success: successBlock },
    ecdn10AgentAPI,
    monitorData: new MonitorData(),
    success,
    tenConfig
  };
};

const getMonitorData = async (): Promise<MonitorData> => {
  return ecdn10AgentAPI
    .gatherDownloadMonitorInfo(undefined)
    .then(async response => {
      // SRV-1588: Agent returning -nan instead of a number for some values.
      const text = await response.text();
      return JSON.parse(text.replace(/:\s*-nan/g, ': 0'));
    })
    .catch(e => {
      log.info('DownloadMonitorInfo call failed', e);
      return new MonitorData();
    });
};

async function get10AgentInfo(): Promise<Ecdn10Data> {
  const out = await getAgentData();
  if (!out.success) {
    setTenData(out);
    return Promise.resolve(out);
  }
  const monitorData = await getMonitorData();
  const data = { ...out, monitorData };
  setTenData(data);
  return Promise.resolve(data);
}
export default get10AgentInfo;
